import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useHistory, useParams } from "react-router"
import Button from "../../../../components/Button"
import InputField from "../../../../components/InputField"
import {
  countryOptions
} from "../../../../components/patientEditForm/DropdownList"
import Toast from "../../../../components/Toast"

import { MocUserRole } from "core/services/models/Enums"
import fileUtils from "fileUtils"
import Select from "react-select"
import {
  createCenterDetail, getCenterDetail,
  updateCenterDetail,
  uploadSpecificFile
} from "../../../../core/services/api"
import "./AddCenter.scss"
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'


export default function AddCenter() {
  const [centerDetail, setCenterDetail] = useState<any>({
    centerName: "",
    contactNumber: "",
    email: "",
    bedSlotDuration: "",
    openTime: "",
    closeTime: "",
    colorCode: "",
    slotDuration: "",
    ipdBookLimitDate: "",
    centerAdminDiscountThreshold: "",
    primaryConsultantDiscountThreshold: "",
    primaryRmoPhoneNumber: "",
    primaryRmoName: "",
    ccAvenueSubAccountId: "",
    brandName: "",
    companyName: "",
    hasLogo: true,
    isWondersoftEnabled: false,
    logoUrl: null
  })
  const [center, setCenter] = useState<any>({})
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [formErrors, setFormErrors] = useState<any>({})
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isSubmit, setIsSubmit] = useState<boolean>(false)

  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);
  const history = useHistory()
  const userRole = useSelector((state: any) => state?.user?.role)
  const { id }: any = useParams()

  const validate = (values: any) => {
    const errors: any = {}
    const emailPattern: any = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const isEmailValid: any = emailPattern.test(values?.email);
    if (!values?.centerName) {
      errors.centerName = "Center Name is required!"
    }

    if (!values?.contactNumber) {
      errors["contactNumber"] = "Phone number is required!"
    } else if (!/^[6-9]{1}[0-9]{9}$/.test(values?.contactNumber)) {
      errors["contactNumber"] = "Please enter correct phone number"
    }

    if (!values?.email) {
      errors["email"] = "Email is required!"
    } else if (!isEmailValid) {
      errors["email"] = "Please enter correct Email"
    }

    if (!values?.openTime) {
      errors["openTime"] = "Open Time is required!"
    }

    if (!values?.closeTime) {
      errors["closeTime"] = "Close Time is required!"
    }

    if (!values?.address?.state) {
      errors["state"] = "State is required!"
    }

    if (!values?.address?.district) {
      errors["district"] = "District is required!"
    }

    if (!values?.bedSlotDuration) {
      errors["bedSlotDuration"] = "Bed Slot Duration is required!"
    }

    if (!values?.address?.addressLine1) {
      errors["addressLine1"] = "AddressLine1 is required!"
    }

    if (!values?.address?.pincode) {
      errors["pincode"] = "Pincode is required!"
    } else if ((values?.address?.pincode?.length < 6 && !(values?.address?.pincode?.length === 0)) || values?.address?.pincode?.length > 6) {
      errors.pincode = "Pincode must be of 6 digits"
    }

    if (!values?.address?.country) {
      errors["country"] = "Country is required!"
    }
    if (!values?.address?.geoLocation) {
      errors["geoLocation"] = "Maps link is required!"
    }

    if (!values?.address?.suburb) {
      errors["suburb"] = "Suburb is required!"
    }

    if (!values?.colorCode) {
      errors["colorCode"] = "Color Code is required!"
    }

    if (!values?.slotDuration) {
      errors["slotDuration"] = "Slot Duration is required!"
    }

    return errors
  }

  function handleSubmit(e?: any) {
    e?.preventDefault()
    e?.stopPropagation()
    setFormErrors(validate(centerDetail))
    setIsSubmit(true)
  }

  function scroll(): void {
    const sectionMap: Record<string, string> = {
      centerName: "section1",
      contactNumber: "section2",
      email: "section3",
      colorCode: "section4",
      openTime: "section5",
      closeTime: "section6",
      slotDuration: "section7",
      bedSlotDuration: "section8",
      addressLine1: "section9",
      addressLine2: "section10",
      state: "section11",
      pincode: "section12",
      district: "section13",
      suburb: "section14",
      country: "section15",
      geoLocation: "section16",
      brandName: "section17",
      companyName: "section18"
    };

    const titles: string[] = Object.keys(formErrors);
    let temp: string = "";

    // Find the first matching section based on the error keys
    for (let key of titles) {
      if (sectionMap[key]) {
        temp = sectionMap[key];
        break; // Exit the loop once the first match is found
      }
    }

    const element: HTMLElement | null = document.getElementById(temp);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  const handleFile = (e: any) => {
    const file = e?.target?.files[0];

    // Check if a file is selected
    if (!file) {
      return;
    }

    // Check file extension (allow only .pdf)
    const isPDF = fileUtils.validateFileExtensionPdf(file.name, 'pdf');
    if (!isPDF) {
      toggleDisplayToast({ text: "Uploaded file must be a PDF", type: "error", goBack: false });
      return;
    }

    const formData = new FormData();
    formData.append("files", file);

    uploadSpecificFile(formData, false)
      .then((res: any) => {
        setCenterDetail({
          ...centerDetail,
          accessCareProtocol: {
            name: file.name,
            blobUrl: res[0]
          },
        });
      })
      .catch((err: any) => {
        console.error(err?.message);
      });
  };


  function onSave(e?: any) {
    const centerData: any = { ...centerDetail }
    if (!centerData["centerAdminDiscountThreshold"]) {
      delete centerData["centerAdminDiscountThreshold"]
    }
    if (!centerData["primaryConsultantDiscountThreshold"]) {
      delete centerData["primaryConsultantDiscountThreshold"]
    }
    if (id) {
      updateCenterDetail(id, centerData)
        .then(() => {
          setIsLoading(false)
          toggleDisplayToast({
            text: "Successfully updated center details",
            type: "success",
            goBack: true
          })
        })
        .catch((err) => {
          setIsLoading(false)
          toggleDisplayToast({
            text: err?.response?.data?.message
              ? err?.response?.data?.message
              : "Unable to update center details",
            type: "error",
            goBack: false
          })
        })
    } else {
      const temp = { ...centerData }
      temp["patientIdInfo"] = null
      temp["invoiceIdInfo"] = null
      temp["receiptIdInfo"] = null
      createCenterDetail(temp)
        .then(() => {
          setIsLoading(false)
          toggleDisplayToast({
            text: "Successfully created center",
            type: "success",
            goBack: true
          })
        })
        .catch((err) => {
          setIsLoading(false)
          toggleDisplayToast({
            text: err?.response?.data?.message
              ? err?.response?.data?.message
              : "Unable to create center",
            type: "error",
            goBack: false
          })
        })
    }
  }

  const countries = countryOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })

  useEffect(() => {
    if (id) {
      getCenterDetail(id)
        .then((res) => {
          setCenter(res)
          setCenterDetail(res)
          setIsLoading(false)
        })
        .catch((err) => {
          console.error("error in center get", err)
          setIsLoading(false)
        })
    }
  }, [id])

  useEffect(() => {
    scroll()
  }, [isSubmit, formErrors])

  useEffect(() => {
    if (!formErrors || (Object.keys(formErrors)?.length === 0 && isSubmit)) {
      onSave()
    }
  }, [formErrors, isSubmit])

  return (
    <div className="add-center-wrapper">
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }

      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.goBack()
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="header-text">
          {id ? `Edit center- ${center?.centerName}` : "Add New Center"}
        </div>
      </div>
      {
        (id && center?.mocCenterId) && (
          <div className="heading">
            <div className="header-text-mocId">MOC ID : {center?.mocCenterId}</div>
          </div>
        )
      }
      <div className="add-center-content">
        <div className="col-md-6 col-lg-6 input-wrapper" id="section18">
          <div className="label-text">Company Name</div>
          <InputField
            className="col-md-8"
            placeholder="Company Name"
            value={centerDetail?.companyName}
            readOnly={readOnly}
            handleChange={(e) => {
              setCenterDetail({
                ...centerDetail,
                companyName: e.target.value,
              })
            }}
          />
          {formErrors?.companyName && (
            <span className="error">{formErrors?.companyName}</span>
          )}
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section17">
          <div className="label-text">Brand Name</div>
          <InputField
            className="col-md-8"
            placeholder="Brand Name"
            value={centerDetail?.brandName}
            readOnly={readOnly}
            handleChange={(e) => {
              setCenterDetail({
                ...centerDetail,
                brandName: e.target.value,
              })
            }}
          />
          {formErrors?.brandName && (
            <span className="error">{formErrors?.brandName}</span>
          )}
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section1">
          <div className="label-text">Center Name *</div>
          <InputField
            className="col-md-8"
            placeholder="Center Name"
            value={centerDetail?.centerName}
            readOnly={readOnly}
            handleChange={(e) => {
              setCenterDetail({
                ...centerDetail,
                centerName: e.target.value,
              })
            }}
          />
          {formErrors?.centerName && (
            <span className="error">{formErrors?.centerName}</span>
          )}
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section2">
          <div className="label-text">Contact Number *</div>
          <InputField
            className="col-md-8"
            readOnly={readOnly}
            placeholder="Contact Number"
            value={centerDetail?.contactNumber}
            handleChange={(e: any) => {
              const value = e.target.value
              let res = ""
              value?.split("")?.forEach((ele: any) => {
                let k = ele?.charCodeAt(0)
                if (k >= 48 && k <= 57) {
                  res += ele
                }
              })
              if (res?.length <= 10) {
                setCenterDetail({
                  ...centerDetail,
                  contactNumber: res,
                })
              }
            }}
          />
          <span className="error">{formErrors?.contactNumber}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section3">
          <div className="label-text">Email *</div>
          <InputField
            className="col-md-8"
            placeholder="Email"
            value={centerDetail?.email}
            readOnly={readOnly}
            handleChange={(e) => {
              setCenterDetail({
                ...centerDetail,
                email: e.target.value,
              })
            }}
          />
          <span className="error">{formErrors?.email}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section4">
          <div className="label-text">Color Code *</div>
          <InputField
            className="col-md-8"
            placeholder="Color Code"
            value={centerDetail?.colorCode ? centerDetail?.colorCode : "#FFFFFF"}
            type="color"
            readOnly={readOnly}
            handleChange={(e) => {
              setCenterDetail({
                ...centerDetail,
                colorCode: e.target.value,
              })
            }}
          />
          <span className="error">{formErrors?.colorCode}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section5">
          <div className="label-text">Open Time *</div>
          <InputField
            className="col-md-8 time-picker"
            placeholder="Open Time"
            value={centerDetail?.openTime}
            type="time"
            readOnly={readOnly}
            handleChange={(e) => {
              setCenterDetail({
                ...centerDetail,
                openTime: e.target.value,
              })
            }}
          />
          <span className="error">{formErrors?.openTime}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section6">
          <div className="label-text">Close Time *</div>
          <InputField
            className="col-md-8 time-picker"
            placeholder="Close Time"
            value={centerDetail?.closeTime}
            type="time"
            readOnly={readOnly}
            handleChange={(e) => {
              const inputTime = e.target.value;
              const openTime = centerDetail?.openTime;
              if (inputTime >= "00:00" && inputTime <= openTime) {
                toggleDisplayToast({
                  text: "Invalid time. Please enter a closing time before 23:59",
                  type: "error",
                  goBack: false
                })
                e.target.blur();
                return;
              }
              else {
                setCenterDetail({
                  ...centerDetail,
                  closeTime: e.target.value,
                })
              }
            }
            }
          />
          <span className="error">{formErrors?.closeTime}</span>
        </div>

        <div className="col-md-6 col-lg-6 input-wrapper" id="section7">
          <div className="label-text">Appointment Slot Duration (mins) *</div>
          <InputField
            className="col-md-8"
            placeholder="Appointment Slot Duration"
            value={centerDetail?.slotDuration}
            type="number"
            readOnly={readOnly}
            handleChange={(e) => {
              const value = parseFloat(e.target.value);
              if (!isNaN(value) && value > 0) {
                setCenterDetail({
                  ...centerDetail,
                  slotDuration: e.target.value,
                })
              } else {
                setCenterDetail({
                  ...centerDetail,
                  slotDuration: '',
                })
              }
            }}
          />
          <span className="error">{formErrors?.slotDuration}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section8">
          <div className="label-text">Bed Slot Duration (mins) *</div>
          <InputField
            className="col-md-8"
            placeholder="Bed Slot Duration"
            readOnly={readOnly}
            value={centerDetail?.bedSlotDuration}
            type="number"
            handleChange={(e) => {
              const value = parseFloat(e.target.value);
              if (!isNaN(value) && value > 0) {
                setCenterDetail({
                  ...centerDetail,
                  bedSlotDuration: e.target.value,
                })
              } else {
                setCenterDetail({
                  ...centerDetail,
                  bedSlotDuration: ''
                })
              }
            }}

          />
          <span className="error">{formErrors?.bedSlotDuration}</span>
        </div>

        <div className="col-md-6 col-lg-6 input-wrapper" id="section9">
          <div className="label-text">Address Line 1 *</div>
          <InputField
            className="col-md-8"
            placeholder="Address Line 1"
            readOnly={readOnly}
            value={centerDetail?.address?.addressLine1}
            handleChange={(e) => {
              const address = {
                ...centerDetail?.address,
                addressLine1: e.target.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
          />
          <span className="error">{formErrors?.addressLine1}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section10">
          <div className="label-text">Address Line 2</div>
          <InputField
            className="col-md-8"
            placeholder="Address Line 2"
            value={centerDetail?.address?.addressLine2}
            readOnly={readOnly}
            handleChange={(e) => {
              const address = {
                ...centerDetail?.address,
                addressLine2: e.target.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
          />
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section11">
          <div className="label-text">State *</div>{" "}
          <InputField
            className="col-md-8"
            placeholder="State"
            value={centerDetail?.address?.state}
            readOnly={readOnly}
            handleChange={(e) => {
              const address = {
                ...centerDetail?.address,
                state: e.target.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
          />
          <span className="error">{formErrors?.state}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section12">
          <div className="label-text">Pincode *</div>
          <InputField
            type="number"
            className="col-md-8"
            placeholder="Pincode"
            value={centerDetail?.address?.pincode}
            readOnly={readOnly}
            handleChange={(e) => {
              const address = {
                ...centerDetail?.address,
                pincode: e.target.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
          />
          {formErrors?.pincode && (
            <span className="error">{formErrors?.pincode}</span>
          )}
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section13">
          <div className="label-text">District *</div>
          <InputField
            className="col-md-8"
            placeholder="District"
            readOnly={readOnly}
            value={centerDetail?.address?.district}
            handleChange={(e) => {
              const address = {
                ...centerDetail?.address,
                district: e.target.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
          />
          <span className="error">{formErrors?.district}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section14">
          <div className="label-text">Suburb *</div>
          <InputField
            className="col-md-8"
            placeholder="Suburb"
            readOnly={readOnly}
            value={centerDetail?.address?.suburb}
            handleChange={(e) => {
              const address = {
                ...centerDetail?.address,
                suburb: e.target.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
          />
          <span className="error">{formErrors?.suburb}</span>
        </div>

        <div className="col-md-6 col-lg-6 input-wrapper" id="section15">
          <div className="label-text">Country *</div>
          <Select
            className="col-md-8"
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: "1px solid #ccd0e7",
                borderRadius: "10px"
              })
            }}
            options={countries}
            isDisabled={readOnly}
            defaultValue={centerDetail?.address?.country}
            onChange={(option: any) => {
              const address = {
                ...centerDetail?.address,
                country: option?.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
            placeholder="Country"
            value={countries.filter(
              ({ label }: any) => label === centerDetail?.address?.country
            )}
          />
          <span className="error">{formErrors?.country}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper" id="section16">
          <div className="label-text">Maps link *</div>
          <InputField
            className="col-md-8"
            placeholder="Maps link"
            readOnly={readOnly}
            value={centerDetail?.address?.geoLocation}
            handleChange={(e) => {
              const address = {
                ...centerDetail?.address,
                geoLocation: e.target.value,
              }
              setCenterDetail({
                ...centerDetail,
                address,
              })
            }}
          />
          <span className="error">{formErrors?.geoLocation}</span>
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper">
          <label className="label-text">Configurable Appointment Slot for IPD</label>
          <InputField
            className="col-md-8"
            placeholder="Enter Number of Days"
            readOnly={readOnly}
            value={centerDetail?.ipdBookLimitDate}
            handleChange={(e) => {
              const value = parseFloat(e.target.value);
              if (!isNaN(value) && value > 0) {
                setCenterDetail({
                  ...centerDetail,
                  ipdBookLimitDate: e.target.value,
                })
              } else {
                setCenterDetail({
                  ...centerDetail,
                  ipdBookLimitDate: '',
                })
              }
            }
            }
            type="number"
            errorMsg={formErrors?.name}
          />
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper">
          <div className="label-text">GST Number</div>
          <InputField
            className="col-md-8"
            placeholder="GST Number"
            value={centerDetail?.gstNumber}
            readOnly={readOnly}
            handleChange={(e) => {
              setCenterDetail({
                ...centerDetail,
                gstNumber: e.target.value,
              })
            }}
          />
        </div>
        <div className="col-md-6 col-lg-6 input-wrapper">
          <div>
            <label className="label-text">Access Care Protocol</label>
          </div>
          <InputField
            className="col-md-8"
            placeholder="Upload care protocol"
            file={true}
            readOnly={readOnly}
            filename={centerDetail?.accessCareProtocol?.name ? centerDetail?.accessCareProtocol?.name : "Care protocol"}
            handleChange={(e) => {
              handleFile(e)
            }}
          />
        </div>
        {
          userRole === MocUserRole?.SYSTEM_ADMIN && (
            <>
              <div className="col-md-6 col-lg-6 input-wrapper">
                <div className="label-text">Center Admin Discount Threshold</div>
                <InputField
                  className="col-md-8"
                  type="number"
                  value={centerDetail?.centerAdminDiscountThreshold}
                  max="100"
                  handleChange={(e) => {
                    if (e?.target?.value) {
                      if (Number(e?.target?.value) < 101 && Number(e?.target?.value) > 0) {
                        setCenterDetail({
                          ...centerDetail,
                          centerAdminDiscountThreshold: e.target.value,
                        })
                      }
                    } else {
                      setCenterDetail({
                        ...centerDetail,
                        centerAdminDiscountThreshold: e.target.value,
                      })
                    }
                  }}
                />
              </div>
              <div className="col-md-6 col-lg-6 input-wrapper">
                <div className="label-text">Consultant Discount Threshold</div>
                <InputField
                  className="col-md-8"
                  type="number"
                  value={centerDetail?.primaryConsultantDiscountThreshold}
                  max="100"
                  handleChange={(e) => {
                    if (e?.target?.value) {
                      if (Number(e?.target?.value) < 101 && Number(e?.target?.value) > 0) {
                        setCenterDetail({
                          ...centerDetail,
                          primaryConsultantDiscountThreshold: e.target.value,
                        })
                      }
                    } else {
                      setCenterDetail({
                        ...centerDetail,
                        primaryConsultantDiscountThreshold: e.target.value,
                      })
                    }
                  }}
                />
              </div>
              <div className="col-md-6 col-lg-6 input-wrapper">
                <div className="label-text">RMO Ph.No</div>
                <InputField
                  className="col-md-8"
                  value={centerDetail?.primaryRmoPhoneNumber}
                  handleChange={(e) => {
                    const value = e.target.value
                    let res = ""
                    value?.split("")?.forEach((ele: any) => {
                      let k = ele?.charCodeAt(0)
                      if (k >= 48 && k <= 57) {
                        res += ele
                      }
                    })
                    if (res?.length <= 10) {
                      setCenterDetail({
                        ...centerDetail,
                        primaryRmoPhoneNumber: res,
                      })
                    }
                  }}
                  readOnly={readOnly}
                />
              </div>
              <div className="col-md-6 col-lg-6 input-wrapper">
                <div className="label-text">RMO Name</div>
                <InputField
                  className="col-md-8"
                  type="text"
                  value={centerDetail?.primaryRmoName}
                  handleChange={(e) => {
                    setCenterDetail({
                      ...centerDetail,
                      primaryRmoName: e.target.value,
                    })
                  }}
                />
              </div>
              <div className="col-md-6 col-lg-6 input-wrapper">
                <div className="label-text">CC Avenue Sub Account</div>
                <InputField
                  className="col-md-8"
                  type="text"
                  value={centerDetail?.ccAvenueSubAccountId}
                  handleChange={(e) => {
                    setCenterDetail({
                      ...centerDetail,
                      ccAvenueSubAccountId: e.target.value,
                    })
                  }}
                />
              </div>
              <div className="col-md-6 col-lg-6 input-wrapper">
                <div className="d-flex align-items-center"
                  role="button"
                  onClick={() => {
                    setCenterDetail({
                      ...centerDetail,
                      hasLogo: !centerDetail?.hasLogo,
                    })
                  }}>
                  <div>
                    {centerDetail?.hasLogo ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                  </div>
                  <div className="label-text px-1">Has Logo</div>
                </div>
                {centerDetail?.hasLogo &&
                  <div className="input-wrapper">
                    <div className="label-text">Logo URL</div>
                    <InputField
                      className="col-md-8"
                      type="text"
                      value={centerDetail?.logoUrl}
                      handleChange={(e) => {
                        setCenterDetail({
                          ...centerDetail,
                          logoUrl: e.target.value,
                        })
                      }}
                    />
                  </div>}
              </div>
              <div className="col-md-6 col-lg-6 input-wrapper">
                <div className="d-flex align-items-center"
                  role="button"
                  onClick={() => {
                    setCenterDetail({
                      ...centerDetail,
                      isWondersoftEnabled: !centerDetail?.isWondersoftEnabled,
                    })
                  }}>
                  <div>
                    {centerDetail?.isWondersoftEnabled ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                  </div>
                  <div className="label-text px-1">Enable Wondersoft</div>
                </div>
              </div>
            </>
          )
        }
        <div className="col-md-10 button-section">
          <div className="me-3">
            <Button
              outline={true}
              text="Cancel"
              type={"button"}
              disabled={readOnly}
              onClick={() => history.goBack()}
              id="referral-doctor-cancel"
            />
          </div>
          {centerDetail === "" ? (
            ""
          ) : (
            <Button
              type="button"
              text="Save"
              disabled={readOnly}
              onClick={(e: any) => handleSubmit(e)}
              id="referral-doctor-save"
            />
          )}
        </div>
      </div>

      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.goBack) {
              history.goBack()
            }
          }}
          onCloseText="Close"
          onClickText={null}
          onClick={() => null}
          type={displayToast?.type}
        />
      )}
    </div>
  )
}
